export default __webpack_public_path__ + "static/media/file-minus.08780129.svg";